export default __webpack_public_path__ + "locales/vi/UploadPanel.json?hash=e7a5f6a1ec65516ab51e6421b5817c60";